import { useTranslation } from 'react-i18next';

import { SkeletonBase } from '@unified-checkout/design-system';
import { ClockRotateLeft } from '@unified-checkout/design-system/icons/index';

import styles from './header.module.scss';

const Header = ({
  lastUpdated,
  isLoading,
  isError,
}: {
  lastUpdated: string | undefined;
  isLoading: boolean;
  isError: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles['header']}>
      <p className={styles['header__title']}>
        {t('innerLayout.balanceTransfers.balance.title')}
      </p>
      {isLoading ? (
        <SkeletonBase width="12rem" height="1.5rem" />
      ) : (
        !isError &&
        lastUpdated && (
          <div className={styles['header__content']}>
            <p className={styles['header__content-label']}>
              {t('innerLayout.balanceTransfers.balance.balances.lastUpdated', {
                date: lastUpdated,
              })}
            </p>
            {ClockRotateLeft}
          </div>
        )
      )}
    </div>
  );
};

export default Header;
